import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {inject, NgModule, provideAppInitializer} from '@angular/core';
import routes from './app-routing.module';
import {AppComponent} from './app.component';
import {ChartistModule} from 'ng-chartist';
import {BoService} from './services/bo.service';
import {AuthGuardService} from './services/auth.guard.service';
import {ConfigService} from './services/config.service';
import {SignAlertComponent} from './sign-alert/sign-alert.component';
import {ListeDesParticipantsComponent} from './liste-des-participants/liste-des-participants.component';
import {NouveauCompteComponent} from './nouveau-compte/nouveau-compte.component';
import {MesInformationsComponent} from './mes-informations/mes-informations.component';
import {SupportComponent} from './support/support.component';
import {ParametresComponent} from './parametres/parametres.component';
import {ConfigurerGeneralComponent} from './configurer-general/configurer-general.component';
import {GererLesAccesComponent} from './gerer-les-acces/gerer-les-acces.component';
import {AideComponent} from './aide/aide.component';
import {RedirectComponent} from './redirect/redirect.component';
import {RedirectToBoOnlineComponent} from './redirect-to-bo-online/redirect-to-bo-online.component';
import {ConfigurerMaListeComponent} from './configurer-ma-liste/configurer-ma-liste.component';
import {ParticipantDetailDrawerComponent} from './liste-des-participants/participant-detail-drawer/participant-detail-drawer.component';
import {TicketingService} from './services/ticketing.service';
import {AuthClientConfig, AuthModule} from '@auth0/auth0-angular';
import {provideRouter, RouterOutlet} from '@angular/router';
import {AuthExpiredInterceptor} from './interceptors/auth-expired.interceptor';
import {AuthTokenInterceptor} from './interceptors/auth-token.interceptor';
import {MesListesControleComponent} from './mes-listes-controle/mes-listes-controle.component';


@NgModule({
  declarations: [
    AppComponent,
    SignAlertComponent,
    ListeDesParticipantsComponent,
    NouveauCompteComponent,
    MesInformationsComponent,
    SupportComponent,
    GererLesAccesComponent,
    ParametresComponent,
    AideComponent,
    RedirectComponent,
    RedirectToBoOnlineComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ChartistModule,
    RouterOutlet,
    AuthModule.forRoot(),
    ConfigurerMaListeComponent,
    ParticipantDetailDrawerComponent,
    ConfigurerGeneralComponent,
    MesListesControleComponent,
  ],
  providers: [
    provideRouter(routes),
    BoService,
    AuthGuardService,
    ConfigService,
    provideAppInitializer(() => {
      // Appeler inject(...) ici et exécuter directement l'init (ne pas retourner une autre fonction)
      const authConfig = inject(AuthClientConfig);
      const config = inject(ConfigService);
      authConfig.set(config.auth0Config);
    }),
    TicketingService,
    provideHttpClient(withInterceptorsFromDi()),
    // Ordre significatif : AuthTokenInterceptor rafraichit le token sur la requete sortante,
    // AuthExpiredInterceptor traite les 401 sur la reponse. Ne pas inverser.
    {provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true},
  ]
})

export class AppModule {
}
